"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datapoolForBucket = exports.datapoolFromBucket = exports.isDatapoolBucket = void 0;
/** Bucket names are only lowercase, so the datapool code part is as well */
var datapoolBucketRegex = /datapool-[0-9a-z]+/;
var isDatapoolBucket = function (bucketName) {
    return datapoolBucketRegex.test(bucketName);
};
exports.isDatapoolBucket = isDatapoolBucket;
var datapoolFromBucket = function (bucketName) {
    return (0, exports.isDatapoolBucket)(bucketName) ? bucketName.split('-')[1] : bucketName;
};
exports.datapoolFromBucket = datapoolFromBucket;
/**
 * Get the datapool Name by extracting the datapool code (lowercase) and looking it up in the names (uppercase)
 * @param bucketName
 * @param datapoolNames
 */
function datapoolForBucket(bucketName, datapoolNames) {
    return datapoolNames[(0, exports.datapoolFromBucket)(bucketName).toUpperCase()] || '';
}
exports.datapoolForBucket = datapoolForBucket;
//# sourceMappingURL=s3.js.map